// extracted by mini-css-extract-plugin
export var button = "PetSmartLandingPage-module__button___Gfygz";
export var cancel = "PetSmartLandingPage-module__cancel___A90O2";
export var content = "PetSmartLandingPage-module__content___j3QUo";
export var copy = "PetSmartLandingPage-module__copy___kfdCb";
export var desktopDisclaimer = "PetSmartLandingPage-module__desktopDisclaimer___oQaFO";
export var head = "PetSmartLandingPage-module__head____a3Hl";
export var hero = "PetSmartLandingPage-module__hero___Nrv5l";
export var logoDesktop = "PetSmartLandingPage-module__logoDesktop___Ogp3I";
export var logoMobile = "PetSmartLandingPage-module__logoMobile___El2Yd";
export var lottie = "PetSmartLandingPage-module__lottie___tmk1p";
export var mobileDisclaimer = "PetSmartLandingPage-module__mobileDisclaimer___wmwVm";
export var picture = "PetSmartLandingPage-module__picture___fCscG";
export var subLogo = "PetSmartLandingPage-module__subLogo___MpwFB";
export var subhead = "PetSmartLandingPage-module__subhead___nwnPu";
export var texture = "PetSmartLandingPage-module__texture____kqeg";
export var title = "PetSmartLandingPage-module__title___Es4iY";
export var wrapper = "PetSmartLandingPage-module__wrapper___lIi27";